// @flow

import ko from 'rgs-knockout';

import { phonePrettyReprExtend } from 'ko-extender-repr-pretty-phone';

import { mobilePhoneToFromJSExtend } from 'ko-extender-to-from-js-phone';


/*
Алгоритм работы:
- на верстке есть инпут ввода мобильного телефона с data-bind="jqInputmask: '+7 (999) 999-99-99'"
- при вводе пользователем телефона  в observable сохраняется '+7 (123) 456-78-90'
- при отправке на СБЛ отрабатывает mobilePhoneToJSMap и значение телефона сериализуется как '1234567890'
- СБЛ присылает json со значением телефона '1234567890' на UI
- отрабатывает mobilePhoneFromJSMap и в observable сохраняется '+7 (123) 456-78-90'
*/

export const observableMobilePhoneExtend = {
	anonymous: observable => observable
		.extend(phonePrettyReprExtend),
};

export function observableMobilePhone (...args) {
	return ko.observable(...args)
		.extend(observableMobilePhoneExtend);
}

export function observableJSableMobilePhone (...args) {
	return observableMobilePhone(...args)
		.extend({ toFromJS: true })
		.extend(mobilePhoneToFromJSExtend);
}
